module.exports = __webpack_public_path__ + "static/media/logo-figma.4566713a.png";